module.exports = __webpack_public_path__ + "img/turtle.601cb494.png";